import React from "react";
import { useAuth } from "../context/AuthContext";
import Paywall from "../pages/Paywall";

export default function SubscribedRoute({ children }) {
  const { user } = useAuth();
  if (user && user.is_subscribed) return children;
  return <Paywall />;
}
